import Feature, { FeatureLike } from 'ol/Feature';
import MapBackgroundsEnum from '@/redux/map/map.enums';

const filledValues: boolean[][] = [];

const LAST_RESOLUTION_VALUE = -1;

let minResolution = -1;
let backgroundId: number = -1;

function getFeatureId(feature: FeatureLike): number | undefined {
  if (feature.getId() === undefined) {
    return undefined;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return parseInt(feature.getId(), 10);
}

export function setFilledBackgroundId(value: number): void {
  backgroundId = value;
}

export function setMinResolution(value: number): void {
  minResolution = value;
}
export function isFeatureFilled(feature: FeatureLike | null, resolution: number): boolean {
  if (!feature) {
    return false;
  }
  if (resolution < minResolution) {
    return false;
  }
  if (backgroundId === MapBackgroundsEnum.NETWORK) {
    return false;
  }
  const id = getFeatureId(feature);
  if (!id) {
    // eslint-disable-next-line no-console
    console.log('Unknown feature id', feature);
    return false;
  }
  if (!filledValues[id]) {
    filledValues[id] = [];
  }
  let filled = filledValues[id][resolution];
  if (filled === undefined) {
    filled = filledValues[id][LAST_RESOLUTION_VALUE];
  }
  return filled;
}

export function setFeatureFilled(feature: Feature, resolution: number, value: boolean): void {
  const id = getFeatureId(feature);
  if (!id) {
    // eslint-disable-next-line no-console
    console.log('Unknown feature id', feature);
    return;
  }
  if (!filledValues[id]) {
    filledValues[id] = [];
  }
  const filled = filledValues[id][resolution];
  if (filled !== undefined && filled !== value) {
    // eslint-disable-next-line no-console
    console.log('different value', feature, resolution, filled, value);
  }

  // if something is wrong with the values then the line below must be uncommented
  // filledValues[id][resolution] = value;
  filledValues[id][LAST_RESOLUTION_VALUE] = value;
}
